/* eslint-disable react/jsx-no-constructed-context-values */
import React, { useState } from "react";
import {
  Link,
  NavLink,
  Outlet,
  useLocation,
  useMatches,
  useNavigate,
} from "react-router-dom";
import {
  Breadcrumb,
  Collapse,
  Container,
  NavDropdown,
  Navbar,
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ToastContainer } from "react-toastify";
import { faCircle, faX } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import Logo from "../assets/icons/boomerang_element-01.svg2";
import MainMenu from "./MainMenu";
import { ConfirmDialogProvider } from "./Builder/Components/ConfirmDialogContext";
import InformationSidePanel from "./HelpContent/InformationSidePanel";
import ContactsModal from "./Builder/Components/modals/ContactsModal";
import ContactSetModal from "./Builder/Components/modals/ContactSetModal";
import ContactEditModal from "./Builder/Components/modals/ContactEdit";
import ReportingModal from "./Builder/Components/modals/ReportingModal";
import LiveChatIcon from "../assets/icons/live_chat.svg2";
import DocsIcon from "../assets/icons/docs.svg2";
import Featues from "./Featues";
import BoomLogoIcon from "../assets/logo_boomlogic.svg2";
import InfoIcon from "../assets/icons/info-01.svg2";
import CollapseButton from "./Common/CollapseButton";
import {
  isHelpButtonsVisible,
  toggleHelpButtons,
} from "./store/slices/featuresSlice";
import { pageProps } from "./helpers/pageProps";
import NewFeature from "./Builder/Components/NewFeature";
import InputArgument from "./Builder/Components/modals/InputArgument";
import TrialModalDropdown from "./Builder/Components/modals/TrialModalDropdown";

import AppSwitcher from "./Common/AppSwitcher";
import VariableGroup from "./Builder/Components/modals/VariableGroup";

const { isSuperadmin, productName, customerName, backURL } = pageProps;

export default function Root() {
  const location = useLocation();
  const dispatch = useDispatch();
  const isHelpButtonsShown = useSelector(isHelpButtonsVisible);
  const matches = useMatches();
  const crumbs = matches
    .filter((match) => Boolean(match.handle?.crumb(match)))
    .map((match) => match.handle.crumb(match));
  const [show, setShow] = useState(
    localStorage.getItem("mainMenuHidden") !== "true"
  );
  document.title = `${crumbs
    .slice(1)
    .map((c) => c.label)
    .reverse()
    .join(" | ")} | Boomlogic`;

  return (
    <ConfirmDialogProvider>
      <InformationSidePanel />
      <ContactsModal />
      <ReportingModal />
      <ContactSetModal />
      <ContactEditModal />
      <InputArgument />
      <VariableGroup />
      <ToastContainer
        position="bottom-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      {isSuperadmin && (
        <div className="bg-danger-subtle fs-6 p-1 border text-center">
          You are in Superadmin mode. | Customer: {customerName} | Product:{" "}
          {productName} | <a href={backURL}>Go back</a>
        </div>
      )}
      <div
        className={`d-md-flex g-0 min-vh-100 ${
          show ? "" : " main-menu-hidden"
        }`}
      >
        <MainMenu
          show={show}
          wrapperClassname="d-none d-md-block"
          dimension="width"
        />
        <div className="flex-grow-1" style={{ minWidth: 0 }}>
          <div className="d-md-flex">
            <Collapse in={!show} dimension="width">
              <div>
                <div className="d-none d-md-block">
                  <div className="nav-color" style={{ height: 60 }} />
                  <div
                    className="bg-brand-gradient-vertical rounded-3 p-3 ms-3"
                    style={{ width: 82, height: 82, marginTop: -50 }}
                  >
                    <Logo className="body-color" width={50} />
                  </div>
                </div>
              </div>
            </Collapse>
            <div className="flex-grow-1">
              <Navbar
                expand={false}
                expanded={show}
                data-bs-theme="dark"
                onToggle={(e) => {
                  setShow(e);
                  localStorage.setItem("mainMenuHidden", (!e).toString());
                }}
                className="nav-color mb-3 p-0"
                style={{ minHeight: 50 }}
              >
                <div
                  className="nav-color align-self-stretch z-n1"
                  style={{
                    width: 500,
                    marginLeft: -500,
                    marginTop: -8,
                    marginBottom: -8,
                  }}
                />
                <Container
                  fluid
                  className="justify-content-start d-block d-flex align-self-stretch"
                >
                  <Navbar.Toggle
                    aria-controls="offcanvasNavbar-expand-lg"
                    className="border-0 ms-3"
                  />
                  <AppSwitcher />
                  <div className="flex-grow-1 d-flex justify-content-end align-items-center me-5">
                    {/* <TrialModalDropdown /> */}
                    <div className="bg-colored text-white rounded-pill d-flex align-items-center justify-content-between gap-2 p-1">
                      <CollapseButton
                        onClick={() => {
                          window.openHaloChat();
                        }}
                        label={
                          <LiveChatIcon
                            width={40}
                            className="bg-white rounded-circle p-1"
                          />
                        }
                        content={
                          <div className="h-100 d-flex gap-1 align-items-center">
                            <span className="fs-5 text-nowrap">Live Chat</span>
                            <FontAwesomeIcon
                              icon={faCircle}
                              style={{ color: "#56ff5e" }}
                            />
                          </div>
                        }
                      />
                      <CollapseButton
                        as="a"
                        href="https://help.uatboomcomms.com/"
                        target="_blank"
                        rel="noreferrer"
                        label={
                          <DocsIcon
                            width={40}
                            className="bg-white rounded-circle p-1"
                          />
                        }
                        content={
                          <div className="h-100 d-flex align-items-center text-white fs-5">
                            Knowledgebase
                          </div>
                        }
                      />

                      <CollapseButton
                        onClick={() => dispatch(toggleHelpButtons())}
                        label={
                          <InfoIcon
                            width={40}
                            className={`${
                              isHelpButtonsShown ? "bg-white" : "bg-secondary"
                            } rounded-circle p-1`}
                          />
                        }
                        content={
                          <div className="h-100 d-flex gap-1 align-items-center">
                            <span className="fs-5 text-nowrap">
                              {isHelpButtonsShown
                                ? "Hide help buttons"
                                : "Show help butons"}
                            </span>
                          </div>
                        }
                      />
                    </div>
                  </div>
                </Container>
              </Navbar>
              <MainMenu show={show} wrapperClassname="d-md-none" />
              <Container
                fluid
                className="px-5 py-1 d-flex justify-content-between align-items-center"
              >
                <Breadcrumb>
                  {crumbs.map((crumb, index) => (
                    <Breadcrumb.Item
                      key={`${index}-${crumb.href}`}
                      active={index === crumbs.length - 1}
                      linkAs={NavLink}
                      linkProps={{
                        to: crumb.href,
                        className: `text-decoration-none text-body`,
                      }}
                    >
                      {crumb.label}
                    </Breadcrumb.Item>
                  ))}
                </Breadcrumb>
                {![
                  "/",
                  "/assets",
                  "/monitoring",
                  "/interactions",
                  "/settings",
                  "/reports",
                  "/library",
                  "/billing",
                  "/products",
                ].includes(location.pathname) && (
                  <Link
                    to={`/${location.pathname
                      .split("/")
                      .slice(1, -1)
                      .join("/")}`}
                    className="btn btn-purple-reverse rounded-pill"
                  >
                    <FontAwesomeIcon icon={faX} />
                  </Link>
                )}
              </Container>
              <hr className="border-top border-tertiary opacity-75 my-0" />
            </div>
          </div>
          <Container fluid className="px-5 mb-5">
            <Outlet />
          </Container>
        </div>
      </div>
    </ConfirmDialogProvider>
  );
}
